export default "__VITE_ASSET__DhbcwQ4$__"